import React, { Component } from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

class Reservation extends Component {
  render() {
    const reservation = JSON.parse(this.props.location.state.reservation);
    const endDate = moment(reservation.end_date, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(reservation.start_date, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="content-history">
        <div className="container-history-title">
          <div className="row">
            <div className="col-md-12">
              <h2 className="page-header">{t('dashboard.history.heading')}</h2>
            </div>
          </div>
        </div>
        <div className="container-history">
          <div className="container-room-header card-panel panel panel-default card">
            <div className="panel-heading" style={{ backgroundImage: "url('" + reservation.picture + "')" }}>
            </div>
            <div className="card-panel-body">
              <div className="panel-body-title">
                <h4 className="ioscentro">{reservation.center_name}</h4>
                <h4 className="iossala">{reservation.name}</h4>
              </div>
              <div className="panel-body-description">
                <div className="panel-description-text">
                  {reservation.description}
                </div>
                <div className="contenedor-flexbox">
                  <div className="contenedor">
                    <i className="fa fa-users" aria-hidden="true">
                    </i>
                    Capacidad para {reservation.capacity} personas.
                  </div>
                  <div className="contenedor">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    {startDate.format('LL')}
                  </div>
                  <div className="contenedor">
                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                    {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                  </div>
                  <div className="contenedor">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                    {reservation.center_city}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-room-description">
            <h4 className="page-header text-primary">
              <strong>{t('dashboard.history.heading_services')}</strong>
            </h4>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <strong>{t('dashboard.history.heading_included')}</strong>
                </p>
                <ul>
                  {reservation.services.map((service, index) =>
                    <li key={index}>{service.name}</li>
                  )}
                </ul>
              </div>
              <div className="col-md-6">
                <p>
                  <strong>{t('dashboard.history.heading_extras')}</strong>
                </p>
                <ul>
                  {reservation.extras.map((service, index) =>
                    <li key={index}>{service.name}</li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="container-room-direction">
          <div className="container-direction text">
            <h4 className="page-header text-primary">
              <strong>{t('dashboard.history.heading_address')}</strong>
            </h4>
            <p>
              <strong>{reservation.name}</strong>
              {reservation.center_address.split(",").map((row, index) =>
                <span key={index} style={{ textTransform: "capitalize" }}>
                  <br />
                  {row.toLowerCase()}
                </span>
              )}
            </p>
          </div>
          <div className="container-direction mapa">
            <h4 className="page-header text-primary">
            </h4>
            <div className="iframe-wrapper">
              <iframe
                frameBorder="0"
                src={
                  "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                  + reservation.center_latitude
                  + "%2C"
                  + reservation.center_longitude
                }
                title={t('dashboard.reservation.frame_center')}>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(Reservation);



// WEBPACK FOOTER //
// ./src/dashboard/history/Reservation.js